
import React from 'react'

const Price = () => {
  return (
    <div className='PriceContainer'>
      <h2> Price</h2>
      <ul>
        <li>Class 5</li>
        <li>✅ class $75 ⏰1:00h</li>
        <li>✅ class $110 ⏰1:30h</li>
        <li>✅ class $140 ⏰2:00h</li>
        <li></li>
        <li>Class 7</li>
        <li>✅ class $85 ⏰1:00h</li>
        <li>✅ class $125 ⏰1:30h</li>
        <li></li>
        <li>✅ car rental for the road test $120</li>
      </ul>
    </div>
  )
}

export default Price